<div class="overlay-notifications d-flex h-100 flex-column">
    <div class="overlay-notifications-header mt-4">
        <span class="title">{{ "pt.edp.edponline.notifications.title" | translate }}</span>

        <span class="subtitle edp-text-seaweed-green" (click)="openPushConfigs()">
            {{"pt.edp.edponline.notifications.config" | translate }}</span>
    </div>
    <edp-loader *ngIf="!fullNotificationsList.length && !isLoaded" [size]="'sm'" [position]="'center'"></edp-loader>
    <div *ngIf="fullNotificationsList.length || isLoaded" class="overlay-notifications-body h-100">
        <div class="tabs">
            <ul ngbNav #nav="ngbNav" class="nav" [(activeId)]="tabSelected">
                <li class="nav-item" [ngbNavItem]="'CONTRACT'">
                    <a class="nav-link" ngbNavLink (click)="onTabChange('CONTRACT')">
                        <span>{{ contract?.Nickname | truncate: 20 }}</span>
                    </a>
                </li>

                <li class="nav-item" [ngbNavItem]="'ALL'">
                    <a class="nav-link" ngbNavLink (click)="onTabChange('ALL')">
                        <span>{{ "pt.edp.edponline.notifications.tab" | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="overlay-notifications-wrapper">
            <ng-container *ngFor="let notification of notificationsList">
                <edp-e-notification-card [card]="notification" (clicked)="markReaded(notification)"></edp-e-notification-card>
            </ng-container>
            <div class="overlay-notifications-empty" *ngIf="!notificationsList.length">
                {{ "pt.edp.edponline.notifications.empty" | translate }}
            </div>
        </div>
    </div>
</div>